export const SMART_T_STEP = {
  NONE: "none",
  UPLOAD_PASSPORT: "uploadPassport",
  PART_A_1: "partA1.1",
  PART_A_2: "partA1.2",
  PART_B: "partB",
  PART_C: "partC",
  PART_D: "partD",
  PART_E: "partE",
  UPLOAD_DOCUMENT: "uploadDocument",
  COMPANY_UPLOAD_DOCUMENT: "companyUploadDocument",
  SURVEY: "survey",
  PART_F: "partF",
  PART_G: "partG",
  FROM_A: "fromA",
  SUMMARIZE: "summarize",
  VISA_INSUANCE: "visaInsuance",
  HEALTH_INSUANCE: "healthInsuance",
  ADD_JOB_POSITION: "addJobPosition",
  UPDATE_JOB_POSITION: "updateJobPositon",
  ADD_COMPAMY_INVESTMENT: "addCompanyInvestment",
  UPDATE_COMPANY_INFO: "updateCompanyInfo",
  INSTITUTION_COMPANY: "InstitutionCompany",
  EMPLOYEE_LIST: "employeeList",
  TERMINATION: "Termination",
};

export const HOME_TAB = {
  EMPLOYEE_LIST: 0,
  COMPANY: 1,
  HISTORY: 2,
  // INFORMATION: 0,
  // SMART_VISA_SERVICE: 1,
  // SECTION_24_SERVICE: 1,
  // CHECK_STATUS: 2,
  // PERSONAL_REFERENCE: 3,
  // CONTACT_US: 3,
};
